import promotionApi from "@/apis/PromotionApi";

const promotionService = {
  async getPromotions(pointId) {
    return await promotionApi.getPromotions(pointId);
  }
}

export default promotionService;